import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth'
import { Link, Widget, Color } from '@/api'
import { debounce } from 'lodash'
import { Bilety24EventDate } from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    availableWidgets: {},
    availableLinkOptions: [],
    widgetTypes: [],
    fieldTypes: {},
    defaultLanguage: 'pl',
    selectedLanguage: 'pl',
    languages: [
      { code: 'pl', label: 'Polski', flag: '/flags/pl.svg' },
      { code: 'en', label: 'Angielski', flag: '/flags/en.svg' }
    ],
    colors: [],
    eventsToAssignBilety24: []
  },
  mutations: {
    setAvailableWidgets(state, payload) {
      state.availableWidgets = payload
    },
    setAvailableLinkOptions(state, payload) {
      state.availableLinkOptions = payload
    },
    setWidgetTypes(state, payload) {
      state.widgetTypes = payload
    },
    setAvailableFields(state, payload) {
      state.availableFields = payload
    },
    setFieldTypes(state, payload) {
      state.fieldTypes = payload
    },
    setColors(state, colors) {
      state.colors = colors
    },
    setEventsToAssignBilety24(state, events) {
      state.eventsToAssignBilety24 = events
    }
  },
  actions: {
    fetchAvailableWidgets({ commit }) {
      return Widget.available()
        .then(response => {
          commit('setAvailableWidgets', response.data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    fetchAvailableLinkOptions: debounce(function ({ dispatch }) {
      dispatch('_fetchAvailableLinkOptions')
    }, 500),
    _fetchAvailableLinkOptions({ commit }) {
      Link.availableLinkOptions()
        .then(response => {
          commit('setAvailableLinkOptions', response.data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    fetchWidgetTypes({ commit }) {
      return Widget.types().then(response => {
        commit('setWidgetTypes', response.data)
      })
    },
    fetchColors({ commit }) {
      Color.get().then(response => {
        commit('setColors', response.data.colors)
      })
    },
    fetchEventsToAssignBilety24({ commit }) {
      Bilety24EventDate.eventsToAssign().then(response => {
        commit('setEventsToAssignBilety24', response.data)
      })
    }
  },
  getters: {},
  setters: {},
  modules: {
    auth
  }
})
